import React from "react";

import { SwimLanesContext } from "./context/SwimLanesContext";
import { Header } from "./sections/Header";
import { Main } from "./sections/Main";

export default function SwimLanesLayout({ children }) {
  return (
    <SwimLanesContext.Provider value={{}}>
      <div className="relative flex flex-col rounded-md bg-white px-6 pt-6">
        {children && React.Children.map(children, (child) => React.cloneElement(child))}
      </div>
    </SwimLanesContext.Provider>
  );
}

SwimLanesLayout.Header = Header;
SwimLanesLayout.Main = Main;
